import { h } from "preact";
import { useState, useMemo } from "preact/hooks";

import { ProductSelector } from "./ProductSelector.js";
import { CalculatorPvd } from "./calculators/CalculatorPvd.js";
import { CalculatorZip } from "./calculators/CalculatorZip.js";
import { CalculatorCraft } from "./calculators/CalculatorCraft.js";
import { OrderButton } from "./OrderButton.js";
import { OrderPopup } from "./OrderPopup.js";
import { markups as allMarkups } from "../../data/markups.js";
import { capitalize } from "../../utils/format.js";

const PRODUCTS = {
  pvd: { title: "ПВД пакеты", Component: CalculatorPvd },
  craft: { title: "КРАФТ пакеты", Component: CalculatorCraft },
  zip: { title: "ЗИП пакеты", Component: CalculatorZip },
};

export function Calculator() {
  const [productId, setProductId] = useState("pvd");
  const [showOrderPopup, setShowOrderPopup] = useState(false);
  const [calcState, setCalcState] = useState(null);
  const [calcPrice, setCalcPrice] = useState(0);

  const Active = PRODUCTS[productId].Component;

  // Описание заказа — формируется из текущего состояния калькулятора
  const orderDescription = useMemo(() => {
    if (!calcState) return "";
    const totalQuantity = calcState.quantity || calcState.quantity_manual;
    const markupTitles = calcState.markups
      .map((i) => allMarkups[i]?.title)
      .filter(Boolean)
      .join(", ");

    return [
      `Тип: ${PRODUCTS[productId].title}`,
      calcState.handle ? `Ручка: ${capitalize(calcState.handle)}` : null,
      `Размер: ${calcState.size}см`,
      `Цвет: ${capitalize(calcState.color)}`,
      calcState.density ? `Плотность: ${calcState.density}` : null,
      `Нанесение: ${calcState.face_colors} + ${calcState.rear_colors}` +
        (calcState.same_print ? ", одинаковые макеты" : ""),
      `Количество: ${totalQuantity}`,
      markupTitles ? `Наценки: ${markupTitles}` : null,
      `Стоимость: ${calcPrice}₽.`,
    ].filter(Boolean).join("; ");
  }, [calcState, calcPrice, productId]);

  // Ключевой момент — при смене продукта сбрасываем состояние
  function selectProduct(id) {
    setProductId(id);
    setCalcState(null);
    setCalcPrice(0);
  }

  // Колбэк от дочернего калькулятора — сообщает актуальное состояние
  function handleCalcChange(state, total) {
    setCalcState(state);
    setCalcPrice(total);
  }

  return h("div", { class: "calc" },
    h(ProductSelector, {
      products: PRODUCTS,
      productId,
      onchange: selectProduct,
    }),

    h(Active, { key: productId, onchange: handleCalcChange }),

    h("div", { class: "calc__actions" },
      h(OrderButton, {
        onclick: () => setShowOrderPopup(true),
      })
    ),

    showOrderPopup && h(OrderPopup, {
      orderData: { description: orderDescription },
      onclose: () => setShowOrderPopup(false),
    })
  );
}
